import { useCallback } from 'react';
import { useSignInState } from './signInState';
import { bffRequestHeaders } from '../services/bffFetch';

function useAuthHeader(_scope: string, method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | undefined): () => Promise<RequestInit> {
  const { signInState } = useSignInState();

  const getAuthHeader = useCallback(async () => ({
    ...(method ? { method } : {}),
    credentials: 'include' as RequestInit['credentials'],
    headers: bffRequestHeaders(signInState.currentCustomerID),
  }), [method, signInState.currentCustomerID]);

  return getAuthHeader;
}

export { useAuthHeader };
